import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RecipeOverrideRemovalDialogProps {
  open: boolean;
  title: string;
  message: string;
  reason: string;
  isProcessing: boolean;
  onReasonChange: (reason: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const RecipeOverrideRemovalDialog = ({
  open,
  title,
  message,
  reason,
  isProcessing,
  onReasonChange,
  onConfirm,
  onCancel,
}: RecipeOverrideRemovalDialogProps) => {
  const { t } = useTranslation('recipeV2');

  return (
    <Dialog
      open={open}
      onClose={isProcessing ? undefined : onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}
          sx={{ mt: 1 }}>
          <Typography color="text.secondary">{message}</Typography>
          <TextField
            label={t('compliance.overrideRemovalReason', 'Reason for removing override')}
            value={reason}
            onChange={(event) => onReasonChange(event.target.value)}
            required
            multiline
            rows={3}
            inputProps={{ maxLength: 500 }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="secondary"
          onClick={onCancel}
          disabled={isProcessing}
        >
          {t('actions.cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={isProcessing || !reason.trim()}
        >
          {isProcessing ? t('actions.deleting') : t('actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecipeOverrideRemovalDialog;
